import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import { useSlideshowContext } from '../Slideshow'
import Indicator from './Indicator/Indicator'
import styles from './Indicators.module.scss'

/**
 * The `Indicators`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Indicators (props) {
  const { className } = props
  const { numSlides, onScrollToSlide, slideIndex } = useSlideshowContext()

  const classNameOutput = useMemo(
    () =>
      classNames([className, styles.container, numSlides <= 1 && styles.none]),
    [className, numSlides]
  )
  const items = useMemo(() => Array.from({ length: numSlides }), [numSlides])

  return (
    <div className={classNameOutput}>
      {items.map((_, index) => (
        <Indicator
          key={index}
          isSelected={slideIndex === index}
          onClick={() => onScrollToSlide(index)}
          index={index}
        />
      ))}
    </div>
  )
}

/** @type {object} */
Indicators.propTypes = {
  className: PropTypes.string
}

/** @type {object} */
Indicators.defaultProps = {
  className: ''
}

// Memoize
export default memo(Indicators)
